import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d3mdkn2j3h: FaireBrandEntity = {
  token: "b_d3mdkn2j3h",
  type: "brand",
  name: "Verve Coffee Roasters",
  avatarUrl:
    "https://cdn.faire.com/fastly/dc470fa7521d9d2796b01c2e47678183e0f4ca622490e2b698b027113bca685b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/01e1fe936c26c47106b252fb931b8c08113c40a7072bcf28ca89580e2309f636.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dc470fa7521d9d2796b01c2e47678183e0f4ca622490e2b698b027113bca685b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/01e1fe936c26c47106b252fb931b8c08113c40a7072bcf28ca89580e2309f636.jpeg",
  location: "Santa Cruz, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "Verve Coffee Roasters was established in 2007 when Ryan O'Donovan and Colby Barr started a small local venture along the rugged California coast. Our roots are planted in Santa Cruz, where we remain independently owned and still roast coffee by hand.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:42.446Z",
    importedBy: "entity-db-cli",
  },
};
